module.exports = __webpack_public_path__ + "static/media/4ODA14.7c8aa0dc.jpg";